export default __webpack_public_path__ + "static/media/UnChecked_icon.dafcedc3.svg";